var render, staticRenderFns
import script from "./customHeaderGroup.vue?vue&type=script&lang=js"
export * from "./customHeaderGroup.vue?vue&type=script&lang=js"
import style0 from "./customHeaderGroup.vue?vue&type=style&index=0&id=04830d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04830d52",
  null
  
)

export default component.exports